import { render } from "./DominicanRepublic.vue?vue&type=template&id=4f5a3dea&scoped=true"
import script from "./DominicanRepublic.vue?vue&type=script&lang=js"
export * from "./DominicanRepublic.vue?vue&type=script&lang=js"

import "./DominicanRepublic.vue?vue&type=style&index=0&id=4f5a3dea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5a3dea"]])

export default __exports__